import Button from "@/components/Common/Button";
import useCustomerCreation from "@/hooks/useCustomerCreation";
import CreateCustomerContent from "@/pages/agencies/CreateCustomerContent";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const CreateBrandSubview: FC<{
  agencyId?: number;
  isLargeBrand?: boolean;
  onClose(): void;
  onCreated(companyId: number): void;
}> = ({agencyId, isLargeBrand, onClose, onCreated}) => {
  const {t} = useTranslation(["common", "multi_account"]);

  const customerCreation = useCustomerCreation({agencyId, onSuccess: onCreated});

  return (
    <div className="flex flex-col gap-8">
      <CreateCustomerContent compact customerCreation={customerCreation} isLargeBrand={isLargeBrand} />
      <div className="flex gap-3 px-8">
        <Button
          buttonStyle="White"
          className="h-10 flex-1 px-5 text-sm sm:flex-none"
          isDisabled={customerCreation.isCreating}
          onClick={() => {
            customerCreation.reset();
            onClose();
          }}>
          {t("common:cancel")}
        </Button>
        <Button
          buttonStyle="Gradient"
          className="h-10 flex-1 px-5 text-sm sm:flex-none"
          isDisabled={customerCreation.isCreateDisabled}
          isLoading={customerCreation.isCreating}
          onClick={() => customerCreation.create()}>
          {t("common:create")}
        </Button>
      </div>
    </div>
  );
};

export default CreateBrandSubview;
